module.exports = __webpack_public_path__ + "img/aa_card_image.c1d2caa0.jpg";